import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";

export default function Footer({ prevStep, nextStep, setStep, toStep, setPrevStep, showNext }) {
    
    const flowLanguage = useSelector(e => e.t_lang.selected);
    const handleNext = () => {
        if (setStep && toStep) {
            setStep(toStep)
        } else {
            nextStep();
        }
    }

    const handlePrev = () => {
        if (setPrevStep && toStep) {
            setStep(toStep)
        } else {
            prevStep();
        }
    }
    return (
        <div className="flex justify-center w-full">
            <div className="flex justify-between lg:max-w-[90%] w-full">
                <button
                    onClick={handlePrev}
                    className="border-[#FF6633] border flex items-center gap-x-3 text-black font-medium py-4  vsm:px-6 px-8 rounded-md"
                >
                    <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.5 8.99891L9.5 16.3789" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M1.5 9L9.5 1.62" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span className="notranslate" key={flowLanguage}>
                    {flowLanguage == "Spanish" ? (
                        "ANTERIOR"
                    ) : (
                        "PREVIOUS"
                    )}
                    </span>                   
                </button>
                {showNext == true && (
                    <button
                        onClick={handleNext}
                        className="bg-[#5843BD] flex items-center gap-x-3 text-white font-medium py-3 vsm:px-4  px-6 rounded-md"
                    >
                        <span className="notranslate" key={flowLanguage}>
                        {flowLanguage == "Spanish" ? (
                            "GUARDAR"
                        ) : (
                            "SAVE"
                        )}
                        </span>
                        {/* SAVE */}
                        <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.5 8.99891L1.5 16.3789" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M9.5 9L1.5 1.62" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                )}
            </div>
        </div>
    )
}